export default __webpack_public_path__ + "static/media/breadcrumbs-icon.73141cd0.svg";